export default __webpack_public_path__ + "images/79a6e8bba3eee9fcc44daa5432ed099c-buddhism_small.webp";